// Copyright (c) 2026 GLOBAL MICRO IT TECHNOLOGY SOLUTIONS LIMITED
// Company No. 758762, Dublin, Ireland
// All rights reserved. Proprietary and confidential.

import { type ReactNode } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig, apiScopes } from './msal-config';

const msalInstance = new PublicClientApplication(msalConfig);

// Module-level event callback — registered before React mounts so we never
// miss LOGIN_SUCCESS during MsalProvider's internal handleRedirectPromise.
function warmApiTokenCache(account: Parameters<typeof msalInstance.setActiveAccount>[0]) {
  if (!account) return;
  msalInstance
    .acquireTokenSilent({ ...apiScopes, account })
    .catch(() => {});
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as { account: Parameters<typeof msalInstance.setActiveAccount>[0] };
    if (payload.account) {
      msalInstance.setActiveAccount(payload.account);
      warmApiTokenCache(payload.account);
    }
  }
});

export function AuthProvider({ children }: { children: ReactNode }) {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}

export { msalInstance };
